module.exports = __webpack_public_path__ + "bd5cc46b3ca8a24aa999db6e57b97b4b.gif";